var jobhajDialog = {
    bindings : {
        messages: '<',
        messagesLength: '<',
        dialogClass: '@',
        stepConfirm: '&'
    },
    /**
     * @ngInject
     */
    controller : function JobhajDialogCtrl ($element) {
        
        var ctrl = this;

        function init () {
            // console.log("dialogClass: ", ctrl.dialogClass);
        }

        function link () {
        }

        function scrollToBottom() {
            var dialogComponent = $element[0].querySelector('.dialog-component');
            var dialogFlex = $element[0].querySelector('.dialog-flex');
            var offsetY = 20;
            TweenMax.to(dialogComponent, 0.2, {scrollTo:{y: dialogFlex.offsetHeight - dialogComponent.offsetHeight + offsetY} });
        }

        this.$onInit = init;
        this.$postLink = link;
        this.$onChanges = scrollToBottom;
    },
    templateUrl : './angular/components/dialog.component.html'
};